import * as z from "zod/v4";

export enum CreateTeamType {
  CommentSold = "commentSold",
  ThirdPartyLogistics = "3pl",
  Custom = "custom",
}

const baseCreateTeam = z.object({
  name: z.string(),
  email: z.string(),
  addressName: z.string(),
  street1: z.string(),
  street2: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  country: z.string(),
  country_name: z.string(),
  phone: z.string(),
});

export const commentSoldCreateTeam = baseCreateTeam.extend({
  storeUrl: z.string(),
});

export const customCreateTeam = baseCreateTeam.extend({ storeUrl: z.string() });

export const createTeamUnion = z.discriminatedUnion("teamType", [
  z.object({
    teamType: z.literal(CreateTeamType.CommentSold),
    ...commentSoldCreateTeam.shape,
  }),
  z.object({
    teamType: z.literal(CreateTeamType.ThirdPartyLogistics),
    ...baseCreateTeam.shape,
  }),
  z.object({
    teamType: z.literal(CreateTeamType.Custom),
    ...customCreateTeam.shape,
  }),
]);

export type ICreateTeamInput = z.infer<typeof createTeamUnion>;
